import { Flex } from '@chakra-ui/react';
import PeerReviewLog from './PeerReview';
import FilesLog from './FilesLog';
import { ReviewerInfo, FileSet } from '@publishing-engine/domain/models';
type AccordionContentProps = {
  peerReviewInfo: ReviewerInfo[];
  fileset: FileSet | null;
  submissionId: string;
};
const AccordionContent: React.FC<AccordionContentProps> = ({
  peerReviewInfo,
  fileset,
  submissionId
}) => {
  return (
    <>
      <Flex flexDirection={'column'} mt="2">
        {peerReviewInfo && peerReviewInfo?.length >= 1 && (
          <PeerReviewLog PeerReviewInfo={peerReviewInfo} />
        )}
        <FilesLog fileset={fileset} submissionId={submissionId} />
      </Flex>
    </>
  );
};

export default AccordionContent;
